import { on } from "@ngrx/store";

import { LoadingState } from "../../../utilities/state.util";
import { JobToolState } from "../../job-tool.reducer";
import { JobCreateActions } from "../job-create-state/job-create.actions";

import { JobFormActionButtonActions } from "./job-form-action-button.actions";

export const jobFormActionButtonReducers = [
  on(JobFormActionButtonActions.createJobButtonClicked, (state: JobToolState): JobToolState => {
    return {
      ...state,
      callState: {
        ...state.callState,
        NewJob: LoadingState.MUTATING,
      }
    }
  }),
  on(JobCreateActions.createJobSuccess, (state: JobToolState): JobToolState => {
    return {
      ...state,
      callState: {
        ...state.callState,
        NewJob: LoadingState.MUTATED,
      }
    }
  }),
  on(JobCreateActions.createJobError, (state: JobToolState, { error }): JobToolState => {
    return {
      ...state,
      callState: {
        ...state.callState,
        NewJob: { error },
      }
    }
  }),
];
